import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import { useChat } from '@/contexts/chat-context'

import { AssistantEmblem } from './assistant-emblem'

/** Matches the Quick find omnibar trigger in main-nav. */
const navTriggerSx = {
	alignItems: 'center',
	background: 'transparent',
	border: '1px solid',
	borderColor: 'divider',
	borderRadius: 1,
	boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
	cursor: 'pointer',
	gap: 1,
	height: 36,
	px: 1.5,
	transition: 'background-color 0.2s, box-shadow 0.2s',
	'&:hover': {
		bgcolor: 'action.hover',
		boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
	},
	'&:focus-visible': {
		outline: '2px solid',
		outlineColor: 'primary.main',
		outlineOffset: 2,
	},
} as const

export function AskAiButton() {
	const { togglePanel, isOpen, hasAccess } = useChat()

	if (!hasAccess) return null

	const tooltip = isOpen
		? 'Assistant open — close from panel or ⌘J'
		: 'Assistant — ask about sales, stores, and inventory'
	const ariaLabel = isOpen ? 'Assistant panel is open' : 'Open assistant'

	return (
		<>
			<Tooltip title={tooltip}>
				<IconButton
					aria-expanded={isOpen}
					aria-label={ariaLabel}
					data-test="assistant-button-mobile"
					onClick={togglePanel}
					sx={{ display: { xs: 'inline-flex', lg: 'none' } }}
				>
					<AssistantEmblem size={30} />
				</IconButton>
			</Tooltip>
			<Tooltip title={tooltip}>
				<Box
					aria-expanded={isOpen}
					aria-label={ariaLabel}
					data-test="assistant-button"
					component="button"
					onClick={togglePanel}
					sx={{
						...navTriggerSx,
						color: 'text.primary',
						display: { xs: 'none', lg: 'flex' },
					}}
					type="button"
				>
					<AssistantEmblem size={24} />
					<Typography
						component="span"
						color="text.secondary"
						sx={{
							fontSize: '0.9375rem',
							fontWeight: 500,
							whiteSpace: 'nowrap',
							userSelect: 'none',
						}}
					>
						Assistant
					</Typography>
					<Typography
						component="kbd"
						sx={{
							color: 'text.secondary',
							display: { xs: 'none', lg: 'inline' },
							fontFamily: 'inherit',
							fontSize: '0.75rem',
							ml: 0.5,
						}}
					>
						⌘J
					</Typography>
				</Box>
			</Tooltip>
		</>
	)
}
